// import React, { useState, useEffect } from "react";
// import TableCompoenent from "../components/TableCompoenent";
// import { API_BASE_URL } from "../../../Config/Config";
// import DropDown from "../../Reports/DummyReportPage/Dropdown";
// import { useDispatch, useSelector } from "react-redux";
// import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
// import Swal from "sweetalert2";
// import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
// import ErrorImg from "./../../../Assets/Images/CommanImages/Error.png";
// import FormInputs from "../DummyReportPage/FormInputs";
// import DropDownMultipleSelection from "../components/FieldsComponent";
// import DropDownCB from "../../CreateBatch/DropdownCB";
// import DropDownMultipleSearchSelection from "../components/FieldsSearchComponent";
// import { format, startOfMonth, endOfMonth, startOfWeek } from "date-fns";

// const DPPSubjectCount = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
// }) => {
//   const [chapterData, setChapterData] = useState([]); // State for chapters
//   const [selectedDppIds, setSelectedDppIds] = useState([]); // For selected DPP IDs

//   const [selectedCourseId, setSelectedCourseId] = useState(""); // Single course_id (previously an array)
//   const [resultsData, setResultsData] = useState([]);
//   const dispatch = useDispatch();
//   const { coursesdata } = useSelector((state) => state.course);
//   const [headers, setHeaders] = useState([]);
//   // const [chapterData, setChapterData] = useState([]);
//   const [isApplied, setIsApplied] = useState(false);
//   const [resetKey, setResetKey] = useState(0);
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [testnamedata, setTestNameData] = useState([]);
//   const [batchData, setBatchData] = useState([]);
//   const [subjectData, setSubjectData] = useState([]);
//   const [dppNameData, setDppNameData] = useState([]); // For storing DPP Names
//   const [selectedBatchIds, setSelectedBatchIds] = useState([]); // For selected batch_ids

//   const [selectedItems, setSelectedItems] = useState([]);
//   const showSelectAll = true;

//   const [value, setValues] = useState({
//     report_title: "",
//     course_id: "",
//     batch_id: "",
//     assessment_id: "",
//     assessment_name: "",
//     description: "",
//     month: "",
//     start_month: "",
//     end_month: "",
//     subject_id: [], // Initialize as an empty array
//     chapter_id: [], // Initialize as an empty array
//   });

//   const [disabled, setDisabled] = useState(false);
//   useEffect(() => {
//     dispatch(fetchCourseData());
//   }, [dispatch]);
//   const fetchBatchesByCourse = async () => {
//     if (!selectedCourseId) return; // Ensure a single course_id is selected

//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-batch-by-course-list-report-searchkey/?course_ids=${selectedCourseId}`
//       );
//       const data = await response.json();
//       setBatchData(data); // Set batch data from the API response
//     } catch (error) {
//       Swal.fire({
//         title: "Error!",
//         text: error.message,
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };

//   const fetchSubjectsByCourse = async () => {
//     if (!selectedCourseId) return; // Ensure a single course_id is selected

//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-subject-by-course-list-report-searchkey/?course_ids=${selectedCourseId}`
//       );
//       const data = await response.json();
//       const formattedData = data.map((item) => ({
//         label: item.subject_name,
//         id: item.subject_id,
//       }));
//       setSubjectData(formattedData);
//     } catch (error) {
//       Swal.fire({
//         title: "Error!",
//         text: error.message,
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };

//   const handleApplyOrReset = async () => {
//     if (isApplied) {
//       // Reset state
//       setIsApplied(false);
//       setValues({
//         report_title: "",
//         assessment_id: "",
//         assessment_name: "",
//         description: "",
//         month: "",
//         start_month: "",
//         end_month: "",
//         subject_id: [],
//         chapter_id: [],
//       });
//       setResultsData([]); // Reset the table data
//       setHeaders([]); // Reset the table headers
//       setSelectedCourseId(""); // Reset selected course_id
//       setSelectedBatchIds([]);
//       setSelectedDppIds([]);
//       setResetKey((prevKey) => prevKey + 1);
//     } else {
//       // Apply state
//       setIsApplied(true);

//       // Determine from_date and end_date based on the selected date range
//       let from_date, end_date;
//       const today = new Date();

//       if (value.month === "Last Month") {
//         from_date = format(
//           startOfMonth(new Date(today.getFullYear(), today.getMonth() - 1)),
//           "yyyy-MM-dd"
//         );
//         end_date = format(
//           endOfMonth(new Date(today.getFullYear(), today.getMonth() - 1)),
//           "yyyy-MM-dd"
//         );
//       } else if (value.month === "Month to Date") {
//         from_date = format(startOfMonth(today), "yyyy-MM-dd");
//         end_date = format(today, "yyyy-MM-dd");
//       } else if (value.month === "Week to Date") {
//         from_date = format(startOfWeek(today, { weekStartsOn: 1 }), "yyyy-MM-dd");
//         end_date = format(today, "yyyy-MM-dd");
//       } else if (value.month === "Custom") {
//         from_date = value.start_month;
//         end_date = value.end_month;
//       } else {
//         // Default to an empty date range if nothing is selected
//         from_date = "2020-06-14"; // Replace with a default date if necessary
//         end_date = "2024-06-14"; // Replace with a default date if necessary
//       }

//       const postData = {
//         batch_ids: selectedBatchIds,
//         assessment_ids: selectedDppIds,
//         subject_ids: value.subject_id,
//         chapter_ids: value.chapter_id,
//       };

//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-dpp-report-subjectwise?course_id=${selectedCourseId}&from_date=${from_date}%2010:46:01.000&end_date=${end_date}%2010:46:01.000`,
//           {
//             method: "POST",
//             headers: {
//               accept: "application/json",
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify(postData),
//           }
//         );

//         const data = await response.json();

//         if (!response.ok) {
//           throw new Error("Failed to fetch report data");
//         }

//         if (data.length > 0) {
//           setHeaders(data[0]); // Set table headers from the first row
//           setResultsData(data.slice(1)); // Set table data excluding the first row (headers)
//         } else {
//           Swal.fire({
//             title: "No Data Found",
//             text: "No results found for the selected filters.",
//             icon: "warning",
//             confirmButtonText: "OK",
//           });
//         }

//         setIsColumnDivVisible(true); // Make the table visible
//       } catch (error) {
//         Swal.fire({
//           title: "Error",
//           text: error.message,
//           icon: "error",
//           confirmButtonText: "OK",
//         });
//       }
//     }
//   };

//   const dropdownStyle = isApplied
//     ? { opacity: 0.5, pointerEvents: "none" }
//     : { opacity: 1, pointerEvents: "auto" };

//   const data = resultsData.map((student) =>
//     headers.map((header, index) => student[index])
//   );

//   useEffect(() => {
//     dispatch(fetchCourseData());
//   }, [dispatch]);

//   const fetchChaptersByCourseAndSubject = async (searchKey) => {
//     if (!searchKey || !selectedCourseId || value.subject_id.length === 0) {
//       return Promise.resolve([]);
//     }

//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-chapter-report-filter-searchkey/?search_key=${searchKey}&course_ids=${selectedCourseId}&subject_ids=${value.subject_id.join(
//           "&subject_ids="
//         )}`
//       );
//       const data = await response.json();

//       return data.map((item) => ({
//         label: item.chapter_name,
//         id: item.chapter_id,
//         Option2: item.subject_name,
//         Option1: item.chapter_name,
//         Option3: item.course_name,
//       }));
//     } catch (error) {
//       Swal.fire({
//         title: "Error!",
//         text: error.message,
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//       return [];
//     }
//   };

//   const handleRadioButtonChange = (selectedValue) => {
//     const today = new Date();

//     if (selectedValue === "Last Month") {
//       const firstDateLastMonth = startOfMonth(
//         new Date(today.getFullYear(), today.getMonth() - 1)
//       );
//       const lastDateLastMonth = endOfMonth(
//         new Date(today.getFullYear(), today.getMonth() - 1)
//       );
//       setValues({
//         ...value,
//         month: selectedValue,
//         start_month: format(firstDateLastMonth, "yyyy-MM-dd"),
//         end_month: format(lastDateLastMonth, "yyyy-MM-dd"),
//       });
//     } else if (selectedValue === "Month to Date") {
//       const firstDateOfCurrentMonth = startOfMonth(today);
//       setValues({
//         ...value,
//         month: selectedValue,
//         start_month: format(firstDateOfCurrentMonth, "yyyy-MM-dd"),
//         end_month: format(today, "yyyy-MM-dd"),
//       });
//     } else if (selectedValue === "Week to Date") {
//       const mondayOfCurrentWeek = startOfWeek(today, { weekStartsOn: 1 });
//       setValues({
//         ...value,
//         month: selectedValue,
//         start_month: format(mondayOfCurrentWeek, "yyyy-MM-dd"),
//         end_month: format(today, "yyyy-MM-dd"),
//       });
//     } else {
//       setValues({ ...value, month: selectedValue });
//     }
//   };

//   const handleCustomRangeChange = (e, field) => {
//     const formattedDate = format(new Date(e.target.value), "yyyy-MM-dd");
//     setValues({ ...value, [field]: formattedDate });
//   };

//   const handleCancel = () => {
//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>Are you sure you want to cancel?</span>
//         </div>
//         <div className="messagebox-insider2">
//           <button
//             className="messagebox-cancel-btn"
//             style={{ marginRight: "10px" }}
//             onClick={() => setIsMessageBoxVisible(false)}
//           >
//             CANCEL
//           </button>
//           <button
//             className="testreportcard-create-btn"
//             onClick={() => window.location.reload()}
//           >
//             PROCEED
//           </button>
//         </div>
//       </div>
//     );

//     setTimeout(function () {
//       setIsMessageBoxVisible(false);
//     }, 9000);

//     setActiveImg(InterogativeImg);
//   };

//   const [focused, setFocused] = useState(false);

//   const handleFocus = () => {
//     setFocused(true);
//   };

//   return (
//     <>
//       <div
//         style={{
//           height: "auto",
//           width: "100%",
//           paddingLeft: "36.5px",
//           marginBottom: "40px",
//         }}
//       >
//         <div style={{ position: "sticky", top: "0" }}>
//           <div className="Header-up">
//             <span style={{ color: "#2F2E40", fontSize: "30px" }}>
//               Batch Subjectwise DPP Count
//             </span>
//             <div
//               className="testreportcard-header-btn-container"
//               style={{ marginRight: "30px" }}
//             >
//               <button
//                 className="testreportcard-cancel-btn"
//                 onClick={handleCancel}
//               >
//                 CANCEL
//               </button>

//               <button
//                 className="testreportcard-create-btn"
//                 onClick={handleApplyOrReset}
//               >
//                 {isApplied ? "RESET" : "APPLY"}
//               </button>
//             </div>
//           </div>
//         </div>
//         <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
//           <div
//             className="col-cs2"
//             style={{ marginRight: "1vw", ...dropdownStyle }}
//             key={`course_${resetKey}`}
//           >
//             <DropDownCB
//               label="Course"
//               style={{ width: "13.5vw" }}
//               selected={selectedCourseId}
//               setSelected={setSelectedCourseId}
//               options={
//                 coursesdata
//                   ? coursesdata.map((course) => ({
//                       id: course.course_id,
//                       label: course.course_description,
//                     }))
//                   : []
//               }
//             />
//           </div>
//           <div
//             className="col-cs2"
//             style={{ marginRight: "1vw", ...dropdownStyle }}
//             key={`batch_${resetKey}`}
//           >
//             <DropDownMultipleSelection
//               label="Batch"
//               width="13.5vw"
//               selected={selectedBatchIds}
//               setSelected={setSelectedBatchIds}
//               options={
//                 batchData.length > 0
//                   ? batchData.map((batch) => ({
//                       label: batch.batch_name,
//                       id: batch.batch_id,
//                     }))
//                   : [{ label: "No batches available", id: "" }]
//               }
//               showSelectAll={true}
//             />

//           </div>
//         </div>
//         <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
//           <div
//             className="col-cs2"
//             style={{ marginRight: "1vw", ...dropdownStyle }}
//             key={`subject_${resetKey}`}
//           >
//               <DropDownMultipleSelection
//               label="Subject"
//               width="13.5vw"
//               selected={value.subject_id}
//               setSelected={(selectedOptions) =>
//                 setValues({ ...value, subject_id: selectedOptions })
//               }
//               options={subjectData}
//               showSelectAll={true}
//             />
//           </div>
//           <div
//             className="col-cs2"
//             style={{ marginRight: "1vw", ...dropdownStyle }}
//             key={`chapter_${resetKey}`}
//           >
//              <DropDownMultipleSearchSelection
//               label="Chapter"
//               width="13.5vw"
//               customWidth="25vw"
//               selected={value.chapter_id}
//               setSelected={(selectedOptions) =>
//                 setValues({ ...value, chapter_id: selectedOptions })
//               }
//               fetchOptions={fetchChaptersByCourseAndSubject} // Fetch chapter data
//               options={chapterData} // Use the formatted data with subject, chapter, and course
//             />
//           </div>
//           <div className="col-cs2"></div>
//           <div
//           className="grid-container-radio-button"
//           style={{ ...dropdownStyle }}
//         >
//           <div className="item5">
//             <div className="toggle-radio">
//               <input
//                 type="radio"
//                 id="last month"
//                 name="month"
//                 value="Last Month"
//                 checked={value.month === "Last Month"}
//                 onChange={() => handleRadioButtonChange("Last Month")}
//                 disabled={disabled}
//               />
//               <label htmlFor="last month">Last Month</label>
//             </div>
//           </div>
//           <div className="item6">
//             <div className="toggle-radio">
//               <input
//                 type="radio"
//                 id="month to date"
//                 name="month"
//                 value="Month to Date"
//                 checked={value.month === "Month to Date"}
//                 onChange={() => handleRadioButtonChange("Month to Date")}
//                 disabled={disabled}
//               />
//               <label htmlFor="month to date">Month to Date</label>
//             </div>
//           </div>
//           <div className="item7">
//             <div className="toggle-radio">
//               <input
//                 type="radio"
//                 id="week to date"
//                 name="month"
//                 value="Week to Date"
//                 checked={value.month === "Week to Date"}
//                 onChange={() => handleRadioButtonChange("Week to Date")}
//                 disabled={disabled}
//               />
//               <label htmlFor="week to date">Week to Date</label>
//             </div>
//           </div>
//           <div className="item8">
//             <div className="toggle-radio">
//               <input
//                 type="radio"
//                 id="custom"
//                 name="month"
//                 value="Custom"
//                 checked={value.month === "Custom"}
//                 onChange={(e) => setValues({ ...value, month: e.target.value })}
//                 disabled={disabled}
//               />
//               <label htmlFor="custom">Custom</label>
//             </div>
//           </div>
//           {value.month === "Custom" && (
//             <>
//               <div className="item9">
//                 <FormInputs
//                   type="month"
//                   name="start_month"
//                   value={value.start_month}
//                   onChange={(e) => handleCustomRangeChange(e, "start_month")}
//                   disabled={disabled}
//                 />
//               </div>
//               <div className="item10">To</div>
//               <div className="item11">
//                 <FormInputs
//                   type="month"
//                   name="end_month"
//                   value={value.end_month}
//                   onChange={(e) => handleCustomRangeChange(e, "end_month")}
//                   disabled={disabled}
//                 />
//               </div>
//             </>
//           )}
//         </div>
//         </div>
//         {/* <div>
//           <label htmlFor="">TEST HAI</label>
//           <DropDownMultipleSelection
//             label="Select Items"
//             selected={selectedItems}
//             setSelected={setSelectedItems}
//             options={[
//               { id: 1, label: "Option 1" },
//               { id: 2, label: "Option 2" },
//               { id: 3, label: "Option 3" },
//             ]}
//             showSelectAll={showSelectAll}
//             // width={"50vw"}
//           />
//         </div> */}
//         <TableCompoenent
//           headers={headers}
//           data={data}
//           searchPlaceholder="Search by Student Name..."
//           isColumnDivVisible={isColumnDivVisible}
//           setIsColumnDivVisible={setIsColumnDivVisible}
//           dataClient={dataClient}
//           testname={testnamedata}
//         />
//       </div>
//     </>
//   );
// };

// export default DPPSubjectCount;

// import React, { useState, useEffect } from "react";
// import TableCompoenent from "../components/TableCompoenent";
// import { API_BASE_URL } from "../../../Config/Config";
// import DropDown from "../../Reports/DummyReportPage/Dropdown";
// import { useDispatch, useSelector } from "react-redux";
// import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
// import Swal from "sweetalert2";
// import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
// import ErrorImg from "./../../../Assets/Images/CommanImages/Error.png";
// import FormInputs from "../DummyReportPage/FormInputs";
// import DropDownMultipleSelection from "../components/FieldsComponent";
// import DropDownCB from "../../CreateBatch/DropdownCB";
// import DropDownMultipleSearchSelection from "../components/FieldsSearchComponent";
// import { format, startOfMonth, endOfMonth, startOfWeek } from "date-fns";

// const DPPSubjectCount = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
// }) => {
//   const [chapterData, setChapterData] = useState([]); // State for chapters
//   const [selectedDppIds, setSelectedDppIds] = useState([]); // For selected DPP IDs

//   const [selectedCourseId, setSelectedCourseId] = useState(""); // Single course_id (previously an array)
//   const [resultsData, setResultsData] = useState([]);
//   const dispatch = useDispatch();
//   const { coursesdata } = useSelector((state) => state.course);
//   const [headers, setHeaders] = useState([]);
//   // const [chapterData, setChapterData] = useState([]);
//   const [isApplied, setIsApplied] = useState(false);
//   const [resetKey, setResetKey] = useState(0);
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [testnamedata, setTestNameData] = useState([]);
//   const [batchData, setBatchData] = useState([]);
//   const [subjectData, setSubjectData] = useState([]);
//   const [dppNameData, setDppNameData] = useState([]); // For storing DPP Names
//   const [selectedBatchIds, setSelectedBatchIds] = useState([]); // For selected batch_ids
//   const [isVisible, setIsVisible] = useState(true); // Default to visible

//   const [selectedItems, setSelectedItems] = useState([]);
//   const showSelectAll = true;

//   const [value, setValues] = useState({
//     report_title: "",
//     course_id: "",
//     batch_id: "",
//     assessment_id: "",
//     assessment_name: "",
//     description: "",
//     month: "",
//     start_month: "",
//     end_month: "",
//     subject_id: [], // Initialize as an empty array
//     chapter_id: [], // Initialize as an empty array    month: "",
//     start_month: "",
//     end_month: "",
//     subject_id: [],
//     chapter_id: [],
//   });

//   const [disabled, setDisabled] = useState(false);
//   useEffect(() => {
//     dispatch(fetchCourseData());
//   }, [dispatch]);

//   // Fetch course data initially
//   useEffect(() => {
//     dispatch(fetchCourseData());
//   }, [dispatch]);

//   // Fetch batches when selectedCourseId changes
//   useEffect(() => {
//     if (selectedCourseId) {
//       fetchBatchesByCourse();
//       fetchSubjectsByCourse();
//     }
//   }, [selectedCourseId]);

//   // Fetch batches by course ID
//   const fetchBatchesByCourse = async () => {
//     if (!selectedCourseId) return;

//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-batch-by-course-list-report-searchkey/?course_ids=${selectedCourseId}`
//       );
//       const data = await response.json();
//       setBatchData(data); // Set batch data from the API response
//     } catch (error) {
//       Swal.fire({
//         title: "Error!",
//         text: error.message,
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };

//   // Fetch subjects by course ID
//   const fetchSubjectsByCourse = async () => {
//     if (!selectedCourseId) return;

//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-subject-by-course-list-report-searchkey/?course_ids=${selectedCourseId}`
//       );
//       const data = await response.json();
//       const formattedData = data.map((item) => ({
//         label: item.subject_name,
//         id: item.subject_id,
//       }));
//       setSubjectData(formattedData);
//     } catch (error) {
//       Swal.fire({
//         title: "Error!",
//         text: error.message,
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };

//   // Fetch chapters based on course ID and subject ID
//   const fetchChaptersByCourseAndSubject = async (searchKey) => {
//     if (!searchKey || !selectedCourseId || value.subject_id.length === 0) {
//       return Promise.resolve([]);
//     }

//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-chapter-report-filter-searchkey/?search_key=${searchKey}&course_ids=${selectedCourseId}&subject_ids=${value.subject_id.join(
//           "&subject_ids="
//         )}`
//       );
//       const data = await response.json();

//       return data.map((item) => ({
//         label: item.chapter_name,
//         id: item.chapter_id,
//         Option2: item.subject_name,
//         Option1: item.chapter_name,
//         Option3: item.course_name,
//       }));
//     } catch (error) {
//       Swal.fire({
//         title: "Error!",
//         text: error.message,
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//       return [];
//     }
//   };

//   const handleApplyOrReset = async () => {
//     if (isApplied) {
//       // Reset state
//       setIsApplied(false);
//       setValues({
//         report_title: "",
//         assessment_id: "",
//         assessment_name: "",
//         description: "",
//         month: "",
//         start_month: "",
//         end_month: "",
//         subject_id: [],
//         chapter_id: [],
//       });
//       setResultsData([]); // Reset the table data
//       setHeaders([]); // Reset the table headers
//       setSelectedCourseId(""); // Reset selected course_id
//       setSelectedBatchIds([]);
//       setSelectedDppIds([]);
//       setResetKey((prevKey) => prevKey + 1);
//     } else {
//       // Apply state
//       setIsApplied(true);

//       // Determine from_date and end_date based on the selected date range
//       let from_date, end_date;
//       const today = new Date();

//       if (value.month === "Last Month") {
//         from_date = format(
//           startOfMonth(new Date(today.getFullYear(), today.getMonth() - 1)),
//           "yyyy-MM-dd"
//         );
//         end_date = format(
//           endOfMonth(new Date(today.getFullYear(), today.getMonth() - 1)),
//           "yyyy-MM-dd"
//         );
//       } else if (value.month === "Month to Date") {
//         from_date = format(startOfMonth(today), "yyyy-MM-dd");
//         end_date = format(today, "yyyy-MM-dd");
//       } else if (value.month === "Week to Date") {
//         from_date = format(
//           startOfWeek(today, { weekStartsOn: 1 }),
//           "yyyy-MM-dd"
//         );
//         end_date = format(today, "yyyy-MM-dd");
//       } else if (value.month === "Custom") {
//         from_date = value.start_month;
//         end_date = value.end_month;
//       } else {
//         // Default to an empty date range if nothing is selected
//         from_date = "2020-06-14"; // Replace with a default date if necessary
//         end_date = "2024-06-14"; // Replace with a default date if necessary
//       }

//       const postData = {
//         batch_ids: selectedBatchIds,
//         subject_ids: value.subject_id,
//         chapter_ids: value.chapter_id,
//       };

//       try {
//         // Perform the API POST request with the dynamic from_date and end_date
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-subjectwise-dpp-count?course_id=${selectedCourseId}&from_date=${from_date} 14:57:12.000&end_date=${end_date} 14:57:12.000`,
//           {
//             method: "POST",
//             headers: {
//               accept: "application/json",
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify(postData),
//           }
//         );

//         const data = await response.json();

//         if (!response.ok) {
//           throw new Error("Failed to fetch report data");
//         }

//         if (data.length > 0) {
//           // Set table headers from the first row and data for the table

//           setHeaders(data[0]);
//           setResultsData(data.slice(1));
//         } else {
//           Swal.fire({
//             title: "No Data Found",
//             text: "No results found for the selected filters.",
//             icon: "warning",
//             confirmButtonText: "OK",
//           });
//         }

//         setIsColumnDivVisible(true); // Make the table visible
//       } catch (error) {
//         Swal.fire({
//           title: "Error",
//           text: error.message,
//           icon: "error",
//           confirmButtonText: "OK",
//         });
//       }
//     }
//   };

//   const tableData = resultsData.map((row) =>
//     headers.map((header, index) => row[index])
//   );

//   const dropdownStyle = isApplied
//     ? { opacity: 0.5, pointerEvents: "none" }
//     : { opacity: 1, pointerEvents: "auto" };

//   const data = resultsData.map((student) =>
//     headers.map((header, index) => student[index])
//   );

//   useEffect(() => {
//     dispatch(fetchCourseData());
//   }, [dispatch]);

//   const handleRadioButtonChange = (selectedValue) => {
//     const today = new Date();

//     if (selectedValue === "Last Month") {
//       const firstDateLastMonth = startOfMonth(
//         new Date(today.getFullYear(), today.getMonth() - 1)
//       );
//       const lastDateLastMonth = endOfMonth(
//         new Date(today.getFullYear(), today.getMonth() - 1)
//       );
//       setValues({
//         ...value,
//         month: selectedValue,
//         start_month: format(firstDateLastMonth, "yyyy-MM-dd"),
//         end_month: format(lastDateLastMonth, "yyyy-MM-dd"),
//       });
//     } else if (selectedValue === "Month to Date") {
//       const firstDateOfCurrentMonth = startOfMonth(today);
//       setValues({
//         ...value,
//         month: selectedValue,
//         start_month: format(firstDateOfCurrentMonth, "yyyy-MM-dd"),
//         end_month: format(today, "yyyy-MM-dd"),
//       });
//     } else if (selectedValue === "Week to Date") {
//       const mondayOfCurrentWeek = startOfWeek(today, { weekStartsOn: 1 });
//       setValues({
//         ...value,
//         month: selectedValue,
//         start_month: format(mondayOfCurrentWeek, "yyyy-MM-dd"),
//         end_month: format(today, "yyyy-MM-dd"),
//       });
//     } else {
//       setValues({ ...value, month: selectedValue });
//     }
//   };

//   const handleCustomRangeChange = (e, field) => {
//     const formattedDate = format(new Date(e.target.value), "yyyy-MM-dd");
//     setValues({ ...value, [field]: formattedDate });
//   };

//   const handleCancel = () => {
//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>Are you sure you want to cancel?</span>
//         </div>
//         <div className="messagebox-insider2">
//           <button
//             className="messagebox-cancel-btn"
//             style={{ marginRight: "10px" }}
//             onClick={() => setIsMessageBoxVisible(false)}
//           >
//             CANCEL
//           </button>
//           <button
//             className="testreportcard-create-btn"
//             onClick={() => window.location.reload()}
//           >
//             PROCEED
//           </button>
//         </div>
//       </div>
//     );

//     setTimeout(function () {
//       setIsMessageBoxVisible(false);
//     }, 9000);

//     setActiveImg(InterogativeImg);
//   };

//   const [focused, setFocused] = useState(false);

//   const handleFocus = () => {
//     setFocused(true);
//   };

//   return (
//     <>
//       <div
//         style={{
//           height: "auto",
//           width: "100%",
//           paddingLeft: "36.5px",
//           marginBottom: "40px",
//         }}
//       >
//         <div style={{ position: "sticky", top: "0" }}>
//           <div className="Header-up">
//             <span style={{ color: "#2F2E40", fontSize: "30px" }}>
//               Batch Subjectwise DPP Count
//             </span>
//             <div
//               className="testreportcard-header-btn-container"
//               style={{ marginRight: "30px" }}
//             >
//               <button
//                 className="testreportcard-cancel-btn"
//                 onClick={handleCancel}
//               >
//                 CANCEL
//               </button>

//               <button
//                 className="testreportcard-create-btn"
//                 onClick={handleApplyOrReset}
//               >
//                 {isApplied ? "RESET" : "APPLY"}
//               </button>
//             </div>
//           </div>
//         </div>
//         <div
//           style={{
//             display: isVisible ? "block" : "none",
//             marginTop: "1vh",
//           }}
//         >
//           <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`course_${resetKey}`}
//             >
//               <DropDownCB
//                 label="Course"
//                 style={{ width: "13.5vw" }}
//                 selected={selectedCourseId}
//                 setSelected={setSelectedCourseId}
//                 options={
//                   coursesdata
//                     ? coursesdata.map((course) => ({
//                         id: course.course_id,
//                         label: course.course_description,
//                       }))
//                     : []
//                 }
//               />
//             </div>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`batch_${resetKey}`}
//             >
//               <DropDownMultipleSelection
//                 label="Batch"
//                 width="13.5vw"
//                 selected={selectedBatchIds}
//                 setSelected={setSelectedBatchIds}
//                 options={
//                   batchData.length > 0
//                     ? batchData.map((batch) => ({
//                         label: batch.batch_name,
//                         id: batch.batch_id,
//                       }))
//                     : [{ label: "No batches available", id: "" }]
//                 }
//                 showSelectAll={true}
//               />
//             </div>
//           </div>
//         </div>
//         <div
//           style={{
//             display: isVisible ? "block" : "none",
//             marginTop: "1vh",
//           }}
//         >
//           <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`subject_${resetKey}`}
//             >
//               <DropDownMultipleSelection
//                 label="Subject"
//                 width="13.5vw"
//                 selected={value.subject_id}
//                 setSelected={(selectedOptions) =>
//                   setValues({ ...value, subject_id: selectedOptions })
//                 }
//                 options={subjectData}
//                 showSelectAll={true}
//               />
//             </div>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`chapter_${resetKey}`}
//             >
//               <DropDownMultipleSearchSelection
//                 label="Chapter"
//                 width="13.5vw"
//                 customWidth="25vw"
//                 selected={value.chapter_id}
//                 setSelected={(selectedOptions) =>
//                   setValues({ ...value, chapter_id: selectedOptions })
//                 }
//                 fetchOptions={fetchChaptersByCourseAndSubject} // Fetch chapter data
//                 options={chapterData} // Use the formatted data with subject, chapter, and course
//               />
//             </div>
//             <div className="col-cs2"></div>
//             <div
//               className="grid-container-radio-button"
//               style={{ ...dropdownStyle }}
//             >
//               <div className="item5">
//                 <div className="toggle-radio">
//                   <input
//                     type="radio"
//                     id="last month"
//                     name="month"
//                     value="Last Month"
//                     checked={value.month === "Last Month"}
//                     onChange={() => handleRadioButtonChange("Last Month")}
//                     disabled={disabled}
//                   />
//                   <label htmlFor="last month">Last Month</label>
//                 </div>
//               </div>
//               <div className="item6">
//                 <div className="toggle-radio">
//                   <input
//                     type="radio"
//                     id="month to date"
//                     name="month"
//                     value="Month to Date"
//                     checked={value.month === "Month to Date"}
//                     onChange={() => handleRadioButtonChange("Month to Date")}
//                     disabled={disabled}
//                   />
//                   <label htmlFor="month to date">Month to Date</label>
//                 </div>
//               </div>
//               <div className="item7">
//                 <div className="toggle-radio">
//                   <input
//                     type="radio"
//                     id="week to date"
//                     name="month"
//                     value="Week to Date"
//                     checked={value.month === "Week to Date"}
//                     onChange={() => handleRadioButtonChange("Week to Date")}
//                     disabled={disabled}
//                   />
//                   <label htmlFor="week to date">Week to Date</label>
//                 </div>
//               </div>
//               <div className="item8">
//                 <div className="toggle-radio">
//                   <input
//                     type="radio"
//                     id="custom"
//                     name="month"
//                     value="Custom"
//                     checked={value.month === "Custom"}
//                     onChange={(e) =>
//                       setValues({ ...value, month: e.target.value })
//                     }
//                     disabled={disabled}
//                   />
//                   <label htmlFor="custom">Custom</label>
//                 </div>
//               </div>
//               {/* {value.month === "Custom" && (
//                 <>
//                   <div className="item9">
//                     <FormInputs
//                       type="month"
//                       name="start_month"
//                       value={value.start_month}
//                       onChange={(e) =>
//                         handleCustomRangeChange(e, "start_month")
//                       }
//                       disabled={disabled}
//                     />
//                   </div>
//                   <div className="item10">To</div>
//                   <div className="item11">
//                     <FormInputs
//                       type="month"
//                       name="end_month"
//                       value={value.end_month}
//                       onChange={(e) => handleCustomRangeChange(e, "end_month")}
//                       disabled={disabled}
//                     />
//                   </div>
//                 </>
//               )} */}
//               {value.month === "Custom" && (
//                 <>
//                   <div
//                     className="item9"
//                     style={{ display: "flex", alignItems: "center" }}
//                   >
//                     <FormInputs
//                       type="month"
//                       name="start_month"
//                       value={value.start_month}
//                       onChange={(e) =>
//                         handleCustomRangeChange(e, "start_month")
//                       }
//                       disabled={disabled}
//                     />
//                     {/* Show selected start date in grey if selected */}
//                     {value.start_month && (
//                       <p
//                         style={{
//                           color: "grey",
//                           marginLeft: "10px",
//                           fontSize: "12px",
//                           width: "90px",
//                         }}
//                       >
//                         {value.start_month}
//                       </p>
//                     )}
//                   </div>

//                   <div className="item10">To</div>

//                   <div
//                     className="item11"
//                     style={{ display: "flex", alignItems: "center" }}
//                   >
//                     <FormInputs
//                       type="month"
//                       name="end_month"
//                       value={value.end_month}
//                       onChange={(e) => handleCustomRangeChange(e, "end_month")}
//                       disabled={disabled}
//                     />
//                     {/* Show selected end date in grey if selected */}
//                     {value.end_month && (
//                       <p
//                         style={{
//                           color: "grey",
//                           marginLeft: "10px",
//                           fontSize: "12px",
//                           width: "90px",
//                         }}
//                       >
//                         {value.end_month}
//                       </p>
//                     )}
//                   </div>
//                 </>
//               )}
//             </div>
//           </div>
//         </div>
//         {/* <div>
//           <label htmlFor="">TEST HAI</label>
//           <DropDownMultipleSelection
//             label="Select Items"
//             selected={selectedItems}
//             setSelected={setSelectedItems}
//             options={[
//               { id: 1, label: "Option 1" },
//               { id: 2, label: "Option 2" },
//               { id: 3, label: "Option 3" },
//             ]}
//             showSelectAll={showSelectAll}
//             // width={"50vw"}
//           />
//         </div> */}

//         <div style={{ position: "relative", marginTop: "20px" }}>
//           <button
//             style={{
//               position: "absolute",
//               top: "-1px",
//               left: "50%",
//               transform: "translateX(-50%)",
//               zIndex: 1,
//               width: "60px",
//               height: "10px",
//               backgroundColor: "white",
//               // borderTopLeftRadius: "100px",
//               // borderTopRightRadius: "100px",
//               border: "none",
//               // borderBottom: "0px !important",
//             }}
//             onClick={() => setIsVisible(!isVisible)}
//           >
//             <p style={{ fontSize: "20px", color: "black" }}>. . .</p>
//           </button>

//           <TableCompoenent
//             headers={headers}
//             data={tableData} // Pass the variable here
//             searchPlaceholder="Search by Student Name..."
//             isColumnDivVisible={isColumnDivVisible}
//             setIsColumnDivVisible={setIsColumnDivVisible}
//             dataClient={dataClient}
//           />
//         </div>
//       </div>
//     </>
//   );
// };

// export default DPPSubjectCount;

import CustomSearchDropdown from "../../POP/FileComp5";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { useSearchParams } from "react-router-dom";
import React, { useState, useEffect, useCallback } from "react";
import TableCompoenent from "../components/TableCompoenent";
import { API_BASE_URL } from "../../../Config/Config";
import { useDispatch, useSelector } from "react-redux";
import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
import FormInputs from "../DummyReportPage/FormInputs";
import DropDownMultipleSelection from "../components/FieldsComponent";
import DropDownCB from "../components/SingleDropdwon";
import { format, startOfMonth, endOfMonth, startOfWeek } from "date-fns";

const mapDataToDropdownFormat = (dataArray, idField, nameField) => {
  // Remove duplicates from the array
  return _.uniqBy(
    dataArray.map((item) => ({
      id: item[idField],
      label: item[nameField],
    })),
    "id"
  );
};

const DPPSubjectCount = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  pauseTimer,
  resumeTimer,
  dataClient,
}) => {
  const [searchColumn, setSearchColumn] = useState(""); // search column
  const navigate = useNavigate();
  // Single course_id (previously an array)
  const [resultsData, setResultsData] = useState([]);
  const dispatch = useDispatch();
  const { coursesdata } = useSelector((state) => state.course);
  const [headers, setHeaders] = useState([]);
  // const [chapterData, setChapterData] = useState([]);
  const [isApplied, setIsApplied] = useState(false);
  const [resetKey, setResetKey] = useState(0);
  const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
  const [testnamedata, setTestNameData] = useState([]);
  const [dppNameData, setDppNameData] = useState([]); // For storing DPP Names
  const [selectedBatchIds, setSelectedBatchIds] = useState([]); // For selected batch_ids
  const [isVisible, setIsVisible] = useState(true); // Default to visible
  const [selectedItems, setSelectedItems] = useState([]);
  const showSelectAll = true;
  const [isExpanded, setIsExpanded] = useState(false); // New state to track the expansion of the table
  const [searchKey, setSearchKey] = useState(""); // State for search key from CustomSearchDropdown
  const [batchData, setBatchData] = useState([]);
  const [subjectData, setSubjectData] = useState([]);
  const [chapterData, setChapterData] = useState([]);
  const [dppData, setDppData] = useState([]);
  const [studentData, setStudentData] = useState([]); // New state for student dropdown
  const [selectedCourseId, setSelectedCourseId] = useState("");
  const [selectedChapters, setSelectedChapters] = useState([]);
  const [selectedDppIds, setSelectedDppIds] = useState([]);
  const [selectedBatches, setSelectedBatches] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]); // New state for selected students
  const [fromDate, setFromDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [value, setValues] = useState({
    report_title: "",
    course_id: "",
    batch_id: "",
    assessment_id: "",
    assessment_name: "",
    description: "",
    month: "",
    start_month: "",
    month: "Month to Date",
    end_month: "",
    subject_id: [], // Initialize as an empty array
    chapter_id: [], // Initialize as an empty array    month: "",
    start_month: "",
    end_month: "",
    subject_id: [],
    chapter_id: [],
  });

  const [searchParams] = useSearchParams();
  const reportName = searchParams.get("reportName");

  useEffect(() => {
    if (selectedCourseId) {
      fetchDropdownData(); // Call only when selectedCourseId is updated and valid
    }
  }, [selectedCourseId]);
  useEffect(() => {
    if (selectedCourseId) {
      fetchDropdownData();
    }
  }, [selectedCourseId]);

  const fetchDropdownData = useCallback(async () => {
    try {
      if (!selectedCourseId) throw new Error("No course selected");

      const response = await fetch(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-dpp-report-filter-searchkey-v2/?course_id=${selectedCourseId}`,
        {
          method: "POST",
          headers: {
            accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            batch_ids: selectedBatches,
            subject_ids: selectedSubjects,
            chapter_ids: selectedChapters,
          }),
        }
      );
      const data = await response.json();

      // Update the data for all dropdowns
      setBatchData(
        mapDataToDropdownFormat(data.batch_list, "batch_id", "batch_name")
      );
      setSubjectData(
        mapDataToDropdownFormat(data.subject_list, "subject_id", "subject_name")
      );
      const uniqueChapters = _.uniqBy(data.chapter_list, "chapter_id");
      setChapterData(
        uniqueChapters.map((item) => ({
          id: item.chapter_id,
          chapter_name: item.chapter_name, // Field for Chapter Name
          subject_name: item.subject_name, // Field for Subject Name
          // batch_name: item.batch_name, // Field for Batch Name
        }))
      );
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }
  }, [selectedCourseId, selectedBatches, selectedSubjects, selectedChapters]);

  const handleDropdownClose = () => {
    // Trigger API call when dropdown closes
    fetchDropdownData();
  };

  useEffect(() => {
    const today = new Date();
    const firstDateOfCurrentMonth = startOfMonth(today);
    setValues({
      ...value,
      start_month: format(firstDateOfCurrentMonth, "yyyy-MM-dd"),
      end_month: format(today, "yyyy-MM-dd"),
    });
  }, []);

  const [disabled, setDisabled] = useState(false);
  useEffect(() => {
    dispatch(fetchCourseData());
  }, [dispatch]);

  // Fetch course data initially
  useEffect(() => {
    dispatch(fetchCourseData());
  }, [dispatch]);

  // Fetch batches when selectedCourseId changes
  useEffect(() => {
    if (selectedCourseId) {
      // fetchBatchesByCourse();
      // fetchSubjectsByCourse();
      fetchDropdownData();
    }
  }, [selectedCourseId]);

  const handleApplyOrReset = async () => {
    if (isApplied) {
      // Reset only table data and headers
      setResultsData([]); // Clear the table data
      setHeaders([]); // Clear the headers
      setIsApplied(false); // Set the state to not applied
      setIsColumnDivVisible(false); // Hide the column div if necessary
    } else {
      // Apply logic
      setIsApplied(true);

      // Determine from_date and end_date based on the selected date range
      let from_date, end_date;
      const today = new Date();

      if (value.month === "Last Month") {
        from_date = format(
          startOfMonth(new Date(today.getFullYear(), today.getMonth() - 1)),
          "yyyy-MM-dd"
        );
        end_date = format(
          endOfMonth(new Date(today.getFullYear(), today.getMonth() - 1)),
          "yyyy-MM-dd"
        );
      } else if (value.month === "Month to Date") {
        from_date = format(startOfMonth(today), "yyyy-MM-dd");
        end_date = format(today, "yyyy-MM-dd");
      } else if (value.month === "Week to Date") {
        from_date = format(
          startOfWeek(today, { weekStartsOn: 1 }),
          "yyyy-MM-dd"
        );
        end_date = format(today, "yyyy-MM-dd");
      } else if (value.month === "Custom") {
        from_date = value.start_month;
        end_date = value.end_month;
      } else {
        from_date = "2020-06-14"; // Default values
        end_date = "2024-06-14";
      }
      setFromDate(from_date);
      setEndDate(end_date);

      // Collect the selected batch_ids, subject_ids, and chapter_ids
      const filteredBatchIds = selectedBatches
        .filter((batch) => batch && batch.id)
        .map((batch) => batch.id);

      const filteredSubjectIds = selectedSubjects
        .filter((subject) => subject && subject.id)
        .map((subject) => subject.id);

      const filteredChapterIds = selectedChapters
        .filter((chapter) => chapter && chapter.id)
        .map((chapter) => chapter.id);

      const postData = {
        course_id: selectedCourseId, // Send selected course ID
        batch_ids: selectedBatches.length > 0 ? selectedBatches : [], // Send batch IDs or empty array
        subject_ids: selectedSubjects.length > 0 ? selectedSubjects : [], // Send subject IDs or empty array
        chapter_ids: selectedChapters.length > 0 ? selectedChapters : [], // Send chapter IDs or empty array
      };

      try {
        // Perform the API POST request with the dynamic from_date and end_date
        const response = await fetch(
          `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-subjectwise-dpp-count?course_id=${selectedCourseId}&from_date=${from_date} 00:00:00&end_date=${end_date} 23:59:59`,
          {
            method: "POST",
            headers: {
              accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(postData), // Send the formatted postData
          }
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error("Failed to fetch report data");
        }

        if (data.length > 0) {
          // Set table headers from the first row and data for the table
          setHeaders(data[0]);
          setResultsData(data.slice(1));
        } else {
          // Handle no data scenario
          setIsMessageBoxVisible(true);
          setMessageBox(
            <div
              className="Container-messageBOX"
              onMouseEnter={pauseTimer} // Use the pauseTimer passed from props
              onMouseLeave={resumeTimer} // Use the resumeTimer passed from props
            >
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>No results found for the selected filters.</span>
              </div>
            </div>
          );
          setActiveImg(InterogativeImg);
        }
      } catch (error) {
        // Handle error scenario
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div
            className="Container-messageBOX"
            onMouseEnter={pauseTimer} // Use the pauseTimer passed from props
            onMouseLeave={resumeTimer} // Use the resumeTimer passed from props
          >
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>{error.message}</span>
            </div>
          </div>
        );
        setActiveImg(InterogativeImg);
      }
    }
  };

  const tableData = resultsData.map((row) =>
    headers.map((header, index) => row[index])
  );

  const dropdownStyle = isApplied
    ? { opacity: 0.5, pointerEvents: "none" }
    : { opacity: 1, pointerEvents: "auto" };

  const data = resultsData.map((student) =>
    headers.map((header, index) => student[index])
  );

  useEffect(() => {
    dispatch(fetchCourseData());
  }, [dispatch]);

  const handleRadioButtonChange = (selectedValue) => {
    const today = new Date();

    if (selectedValue === "Last Month") {
      const firstDateLastMonth = startOfMonth(
        new Date(today.getFullYear(), today.getMonth() - 1)
      );
      const lastDateLastMonth = endOfMonth(
        new Date(today.getFullYear(), today.getMonth() - 1)
      );
      setValues({
        ...value,
        month: selectedValue,
        start_month: format(firstDateLastMonth, "yyyy-MM-dd"),
        end_month: format(lastDateLastMonth, "yyyy-MM-dd"),
      });
    } else if (selectedValue === "Month to Date") {
      const firstDateOfCurrentMonth = startOfMonth(today);
      setValues({
        ...value,
        month: selectedValue,
        start_month: format(firstDateOfCurrentMonth, "yyyy-MM-dd"),
        end_month: format(today, "yyyy-MM-dd"),
      });
    } else if (selectedValue === "Week to Date") {
      const mondayOfCurrentWeek = startOfWeek(today, { weekStartsOn: 1 });
      setValues({
        ...value,
        month: selectedValue,
        start_month: format(mondayOfCurrentWeek, "yyyy-MM-dd"),
        end_month: format(today, "yyyy-MM-dd"),
      });
    } else {
      setValues({ ...value, month: selectedValue });
    }
  };

  const handleCustomRangeChange = (e, field) => {
    const formattedDate = format(new Date(e.target.value), "yyyy-MM-dd");
    setValues({ ...value, [field]: formattedDate });
  };

  const [focused, setFocused] = useState(false);

  const handleFocus = () => {
    setFocused(true);
  };

  const course =
    coursesdata && coursesdata.length > 0
      ? coursesdata.find((course) => course.course_id === selectedCourseId)
        ?.course_description || ""
      : "";

  const getSelectedBatchNames = () => {
    if (selectedBatches.length === 0) return 'All';
    const batchNames = batchData
      .filter((batch) => selectedBatches.includes(batch.id)) // Filter based on selected batch IDs
      .map((batch) => batch.label); // Extract batch names
    return batchNames.join(', '); // Join them as a comma-separated string
  };


  // Function to get a string for selected subjects
  const getSelectedSubjectNames = () => {
    if (selectedSubjects.length === 0) return 'All';
    const subjectNames = subjectData
      .filter((subject) => selectedSubjects.includes(subject.id))
      .map((subject) => subject.label);
    return subjectNames.join(', ');
  };

  // Function to get a string for selected chapters
  const getSelectedChapterNames = () => {
    if (selectedChapters.length === 0) return 'All';
    const chapterNames = chapterData
      .filter((chapter) => selectedChapters.includes(chapter.id)) // Filter based on selected chapter IDs
      .map((chapter) => chapter.chapter_name); // Extract chapter names
    const chapterNamesString = chapterNames.join(', '); // Join them as a comma-separated string
    const maxBatchLength = 129; // Maximum character limit for display
    // If the length of the chapter names string exceeds the maxBatchLength, show "Multiple chapters selected"
    if (chapterNamesString.length > maxBatchLength) {
      return 'Multiple';
    }
    return chapterNamesString;
  };

  return (
    <>
      <div
        style={{
          height: "auto",
          width: "100%",
          paddingLeft: "36.5px",
          marginBottom: "40px",
        }}
      >
        <div style={{ position: "sticky", top: "0" }}>
          <div className="Header-up">
            <span style={{ color: "#2F2E40", fontSize: "30px", textTransform: "capitalize" }}>
              {reportName}
            </span>
            <div
              className="testreportcard-header-btn-container"
              style={{ marginRight: "30px" }}
            >
              <button
                className="testreportcard-cancel-btn"
                onClick={() => navigate(-1)}
              // onClick={handleCancel}
              >
                CANCEL
              </button>

              <button
                className="testreportcard-create-btn"
                onClick={handleApplyOrReset}
              >
                {isApplied ? "RESET" : "APPLY"}
              </button>
            </div>
          </div>
        </div>
        <div
          style={{
            display: isVisible ? "block" : "none",
            marginTop: "1vh",
          }}
        >
          <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
            <div
              className="col-cs2"
              style={{ marginRight: "1vw", ...dropdownStyle }}
              key={`course_${resetKey}`}
            >
              <DropDownCB
                label="Course"
                style={{ width: "13.5vw" }}
                selected={selectedCourseId}
                setSelected={setSelectedCourseId}
                options={
                  coursesdata
                    ? coursesdata.map((course) => ({
                      id: course.course_id,
                      label: course.course_description,
                    }))
                    : []
                }
              />
            </div>
            <div
              className="col-cs2"
              style={{ marginRight: "1vw", ...dropdownStyle }}
              key={`batch_${resetKey}`}
            >
              {/* <DropDownMultipleSelection
                width="13vw"
                label="Select Batch"
                selected={selectedBatches}
                setSelected={setSelectedBatches}
                options={batchData}
                customWidth="100%"
                isRequired={true}
                showSelectAll={true}
              /> */}
              <DropDownMultipleSelection
                label="Select Batch"
                width="13vw"
                selected={selectedBatches}
                setSelected={setSelectedBatches}
                options={batchData}
                showSelectAll={true}
                onDropdownClose={handleDropdownClose} // API call after dropdown closes
                isRequired={false}
              />
            </div>
          </div>
        </div>
        <div
          style={{
            display: isVisible ? "block" : "none",
            marginTop: "1vh",
          }}
        >
          <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
            <div
              className="col-cs2"
              style={{ marginRight: "1vw", ...dropdownStyle }}
              key={`subject_${resetKey}`}
            >
              <DropDownMultipleSelection
                width="13.5vw"
                label="Select Subject"
                selected={selectedSubjects}
                setSelected={setSelectedSubjects}
                options={subjectData}
                customWidth="100%"
                isRequired={false}
                showSelectAll={true}
                onDropdownClose={handleDropdownClose}
              />
            </div>
            <div
              className="col-cs2"
              style={{ marginRight: "1vw", ...dropdownStyle }}
              key={`chapter_${resetKey}`}
            >
              {/* <CustomSearchDropdown
                label="Select Chapter"
                optionsData={chapterData}
                selected={selectedChapters}
                setSelected={setSelectedChapters}
                placeholder="Search for Chapters..."
                isRequired={true}
                headers={["Chapter Name", "Subject", "Batch"]} // Chapter Dropdown Headers
              /> */}

              <CustomSearchDropdown
                label="Select Chapter"
                optionsData={chapterData}
                selected={selectedChapters}
                setSelected={setSelectedChapters}
                placeholder="Search for Chapter..."
                headers={["Chapter Name", "Subject Name"]}
                optionFields={{
                  option1: "chapter_name",
                  option2: "subject_name",
                  // option3: "batch_name",
                }}
                onDropdownClose={handleDropdownClose} // API call after dropdown closes
                customwidth="20vw"
              />
            </div>
            <div className="col-cs2"></div>
            <div
              className="grid-container-radio-button"
              style={{ ...dropdownStyle,  height: "35px" }}
            >
              <div className="item5">
                <div className="toggle-radio">
                  <input
                    type="radio"
                    id="last month"
                    name="month"
                    value="Last Month"
                    checked={value.month === "Last Month"}
                    onChange={() => handleRadioButtonChange("Last Month")}
                    disabled={disabled}
                  />
                  <label htmlFor="last month">Previous Month</label>
                </div>
              </div>
              <div className="item6">
                <div className="toggle-radio">
                  <input
                    type="radio"
                    id="month to date"
                    name="month"
                    value="Month to Date"
                    checked={value.month === "Month to Date"}
                    onChange={() => handleRadioButtonChange("Month to Date")}
                    disabled={disabled}
                  />
                  <label htmlFor="month to date">Month to Date</label>
                </div>
              </div>
              <div className="item7">
                <div className="toggle-radio">
                  <input
                    type="radio"
                    id="week to date"
                    name="month"
                    value="Week to Date"
                    checked={value.month === "Week to Date"}
                    onChange={() => handleRadioButtonChange("Week to Date")}
                    disabled={disabled}
                  />
                  <label htmlFor="week to date">Week to Date</label>
                </div>
              </div>
              <div className="item8">
                <div className="toggle-radio">
                  <input
                    type="radio"
                    id="custom"
                    name="month"
                    value="Custom"
                    checked={value.month === "Custom"}
                    onChange={(e) =>
                      setValues({ ...value, month: e.target.value })
                    }
                    disabled={disabled}
                  />
                  <label htmlFor="custom">Custom</label>
                </div>
              </div>
              {/* {value.month === "Custom" && (
                <>
                  <div className="item9">
                    <FormInputs
                      type="month"
                      name="start_month"
                      value={value.start_month}
                      onChange={(e) =>
                        handleCustomRangeChange(e, "start_month")
                      }
                      disabled={disabled}
                    />
                  </div>
                  <div className="item10">To</div>
                  <div className="item11">
                    <FormInputs
                      type="month"
                      name="end_month"
                      value={value.end_month}
                      onChange={(e) => handleCustomRangeChange(e, "end_month")}
                      disabled={disabled}
                    />
                  </div>
                </>
              )} */}
              {value.month === "Custom" && (
                <>
                  <div className="item9">
                    <FormInputs
                      type="date"
                      name="start_month"
                      value={value.start_month}
                      onChange={(e) =>
                        setValues({ ...value, start_month: e.target.value })
                      }
                      disabled={isApplied}
                    />
                  </div>
                  <div className="item10">To</div>
                  <div className="item11">
                    <FormInputs
                      type="date"
                      name="end_month"
                      value={value.end_month}
                      onChange={(e) =>
                        setValues({ ...value, end_month: e.target.value })
                      }
                      disabled={isApplied}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        {/* <div>
          <label htmlFor="">TEST HAI</label>
          <DropDownMultipleSelection
            label="Select Items"
            selected={selectedItems}
            setSelected={setSelectedItems}
            options={[
              { id: 1, label: "Option 1" },
              { id: 2, label: "Option 2" },
              { id: 3, label: "Option 3" },
            ]}
            showSelectAll={showSelectAll}
            // width={"50vw"}
          />
        </div> */}

        <div style={{ position: "relative", marginTop: "20px" }}>
          {/* <button
            style={{
              position: "absolute",
              top: "-1px",
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 1,
              width: "60px",
              height: "10px",
              backgroundColor: "white",
              // borderTopLeftRadius: "100px",
              // borderTopRightRadius: "100px",
              border: "none",
              // borderBottom: "0px !important",
            }}
            onClick={() => setIsVisible(!isVisible)}
          >
            <p style={{ fontSize: "20px", color: "black" }}>. . .</p>
          </button> */}
          <button
            style={{
              position: "absolute",
              top: "-1px",
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 1,
              width: "60px",
              height: "10px",
              backgroundColor: "white",
              border: "none",
            }}
            onClick={() => {
              setIsVisible(!isVisible);
              setIsExpanded(!isExpanded); // Toggle the isExpanded state when clicked
            }}
          >
            <p style={{ fontSize: "20px", color: "black" }}>. . .</p>
          </button>
          <TableCompoenent
            headers={headers.map((header) => header.substring(2))}
            data={tableData}
            searchPlaceholder="Search by Student Name..."
            isColumnDivVisible={isColumnDivVisible}
            setIsColumnDivVisible={setIsColumnDivVisible}
            dataClient={dataClient}
            isExpanded={isExpanded}
            ReportPageHeader="DPP count per batch and subject"
            course={course}
            batch={getSelectedBatchNames()}
            subject={getSelectedSubjectNames()}
            chapter={getSelectedChapterNames()}   
            dppName={""}
            student={""}
            date={
              fromDate &&
                endDate &&
                dayjs(fromDate).isValid() &&
                dayjs(endDate).isValid()
                ? `${dayjs(fromDate).format("YYYY-MM-DD")} To ${dayjs(
                  endDate
                ).format("YYYY-MM-DD")}`
                : ""
            }
          />
        </div>
      </div>
    </>
  );
};

export default DPPSubjectCount;
